import { render } from "./AboutDialog.vue?vue&type=template&id=5ed641cb"
import script from "./AboutDialog.vue?vue&type=script&lang=js"
export * from "./AboutDialog.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__